export default "__VITE_ASSET__e02396f8__"